export default __webpack_public_path__ + "static/web-analytics-dark-mode-0deac0a77222ed1d4bc5380426c2fde8.mp4";